import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { DrawdownIncomeAmendmentCalculations } from '../../Models/Domains/Drawdown/DrawdownIncomeAmendmentCalculations';

declare var IS_RUNNING_IN_APP_POOL;

export class DrawdownIncomeAmendmentInstructionCalculationsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(instructionId: number): Promise<DrawdownIncomeAmendmentCalculations, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Drawdown/DrawdownIncomeAmendmentInstructionCalculations/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId }

    return AjaxWrapper.get<DrawdownIncomeAmendmentCalculations, any>(url, data);
  }
}

